import React from 'react';

import { LegacyBox, styled, useTheme } from '@gogame/components';
import { useCurrencyFormat } from '@gogame/intl-ts';

import { useGroup } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/Group';
import { useViewStateByResolveName } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/ViewState';
import { getActivityTypeColor } from 'scenes/MarketingPlanning/MarketingPlanningWizard/constants';
import { precision } from 'scenes/MarketingPlanning/utils';

import CircularProgress from './CircularProgress';

const LabelStyled = styled('span')`
  color: ${({ error, theme }) => (error ? theme.palette.error.main : null)};
  min-width: 80px;
`;

const BudgetLeft = () => {
  const { activityType } = useGroup();

  const { budgetLeft, budget } = useViewStateByResolveName();

  const formatCurrency = useCurrencyFormat();
  const formattedBudgetLeft = formatCurrency(budgetLeft);
  const theme = useTheme();

  const progress = React.useMemo(() => {
    const budgetSpent = budget - budgetLeft;
    return budgetSpent
      ? precision(Math.min((budgetSpent / budget) * 100, 100))
      : 0;
  }, [budget, budgetLeft]);

  const error = budgetLeft < 0;

  return (
    <LegacyBox gutter={12} align={'center'}>
      <CircularProgress
        color={getActivityTypeColor(activityType, theme)}
        progress={progress}
        size={30}
        errorIndicatorSize={12}
        error={error}
      />
      <LabelStyled error={error}>{formattedBudgetLeft}</LabelStyled>
    </LegacyBox>
  );
};

export default BudgetLeft;
